<template>
<div>
  <div class="modal message-modal">
    <div class="modal-dialog">
      <div :class="{ 
        'modal-content': true, 
        'modal-error': message.type === 'error', 
        'modal-warning': message.type === 'warn',
        'modal-success': message.type === 'success',
        'modal-clean': message.type === 'clean',
        }">
        <div class="modal-body text-center" v-html="message.context">
        </div>
        <div class="modal-footer" v-if="message.confirm || message.showUnlock">
          <div class="btn btn-white" v-if="message.confirm" @click="closeModal">確定</div>
          <div class="btn btn-white" v-if="message.showUnlock" @click="openDevicesDiff">重新解鎖</div>
          <div class="btn btn-white" v-if="message.showLockDevice" @click="handleDevicesForLockup">問題藥盒上鎖</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';


export default {
  name: 'Message',
  methods: {
    closeModal() {
      this.$store.commit('CLOSE_MESSAGE', true);
    },
    openDevice() {
      this.$store.dispatch('openDevice');
    },
    findDevicesWithSameDrawer(netId) {
      return _.filter(Object.values(this.$store.getters.allDevices), (item) => {
        return item.net.id === netId;
      });
    },
    handleDevicesForLockup() {
      const promise = [];
      this.forLockDevices.forEach((dev) => {
        if (dev.type === 'net') {
          const devicesOnSameNet = this.findDevicesWithSameDrawer(dev.id);
          if (devicesOnSameNet.length === 1) { // only lock up F type
            devicesOnSameNet.forEach((subDev) => {
              promise.push(this.$store.state.instance.patch(`/api/device/${subDev.id}/`, {
                error: true,
              }));
            });
          }
        }
        if (dev.type === 'device') {
          promise.push(this.$store.state.instance.patch(`/api/device/${dev.id}/`, {
            error: true,
          }));
        }
      });

      axios.all(promise)
      .then(() => {
        this.$router.push({ name: 'Main' });
        this.$store.commit('SET_MESSAGE', {
          context: '非預期開啟之裝置已上鎖，請重新執行原動作',
          type: 'warn',
          keepOnTop: true,
        });
      });
    },
    openDeviceByIds() {
      const promise = [];
      if (this.errorDeviceIDs.length !== 0) {
        this.errorDeviceIDs.forEach((id) => {
          this.$store.dispatch('openDevice', id);
        });
      }
    },
    openDevicesDiff() {
      if (this.message.type === 'warn') this.openDevice();
      if (this.message.type === 'error') this.openDeviceByIds();
    },
  },
  mounted() {
    this.$store.commit('MESSAGE_POPED', true);
  },
  destroyed() {
    this.$store.commit('MESSAGE_POPED', false);
  },
  computed: {
    message() {
      return this.$store.state.message;
    },
    errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    forLockDevices() {
      return this.$store.state.device.forLockDevices;
    },
    errorDeviceIDs() {
      const ids = [];
      this.$store.state.device.errorDevices.forEach((dev) => {
        console.log(dev);
        if (dev.type === 'box') {
          // _.filter(Object.values(this.$store.getters.allDevices), { system: dev.net.system.relative_index - 1, drawerId: dev.net.row_id, col: dev.relative_col, row: dev.pos_row });
          // ids.push(_.filter(Object.values(this.$store.getters.syst), { system: dev.net.system - 1, drawerId: dev.net.row_id, col: dev.relative_col, row: dev.pos_row })[0].id);
          ids.push(Object.values(this.$store.getters.systems)[dev.system].net_set[dev.drawerId - 1].device_set[dev.boxId].id);
        }
      });
      return ids;
    },
  },
};
</script>

<style lang="sass">
.modal
  display: flex
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);

.modal-dialog
  // margin-top: 300px !important
  width: 500px !important

.modal-error
  border-color: #FF3811
  background-color: #FF3811
  color: white

.modal-warning
  border-color: #ff960c
  background-color:#ff960c
  color: white

.modal-success
  border-color: #42b883
  background-color: #42b883
  color: white  

.modal-clean
  border-color: gray
  background-color: white
  color: gray

.modal-footer
  justify-content: center
  border: 0
  .btn
    border: 1px solid white

.modal-body
  word-wrap: break-word;
  p
    margin-bottom: 0

.message-modal
  z-index: 1080

.btn-white
  &:active
    background-color: white
    color: gray
</style>




// WEBPACK FOOTER //
// Message.vue?a27c67be